import React, { useState } from 'react'

import styles from './CollapsibleDateFilter.module.scss';
import Calendar from 'react-calendar';
import CustomCalendar from '../../../../components/CustomCalendar/CustomCalendar';

type CollapsibleDateFilterType = {

}

export default function CollapsibleDateFilter({

}: CollapsibleDateFilterType) {
    const [collapse, setCollapse] = useState<boolean>(true);
    const [value, onChange] = useState([new Date(), new Date()]);
    return (
        <div className={styles.filterWrapper}>
            <div className={styles.header} onClick={() => setCollapse(!collapse)}>
                Date Range
                <div>
                    <span className={styles.clear}>Clear</span>
                    <span className={collapse ? 'icon-chevron-down' : 'icon-chevron-up'}></span>
                </div>
            </div>
            <div className={collapse ? styles.collapse : styles.expand}>
                <CustomCalendar  onChange={onChange}></CustomCalendar>
                <div className={styles.bottomWrapper}>
                    <div className={styles.today}>Today</div>
                    <div className={styles.dateWrapper}>
                        <div className={styles.startDate}>{value[0].toLocaleDateString()}</div>
                        <span className={styles.separator}>–</span>
                        <div className={styles.endDate}>{value[1].toLocaleDateString()}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
